<template>
    <ion-toolbar>
        <ion-buttons slot="start" v-if="showButton">
            <template v-if="backUrl">
            <ion-button :router-link="backUrl" router-direction="back" text="" color="dark" :icon="arrowBack" mode="ios">
                <ion-icon slot="icon-only" :icon="arrowBack"></ion-icon>
            </ion-button>
            </template>
            <template v-else>
                <ion-back-button default-href="/home/home/" text="" color="dark" :icon="arrowBack" mode="ios"></ion-back-button>
            </template>
        </ion-buttons>
        <ion-title id="title">{{title}}</ion-title>
    </ion-toolbar>
</template>

<script setup lang="ts">
import {
        IonToolbar,
        IonButtons,
        IonButton,
        IonBackButton,
        IonTitle,
        IonIcon,
    } from '@ionic/vue'
import { arrowBack } from 'ionicons/icons'
import { useRouter, onBeforeRouteLeave, RouteLocation } from 'vue-router';
import type { PropType } from 'vue'
import type RouteLocationRaw from 'vue-router'
const router = useRouter();

const props = defineProps({
    title: {
        type: String,
        default: '',
    },
    backUrl: {
        type: Object as PropType<RouteLocation | undefined> | string | any, 
        default:'',
    },
    showButton: {
      type: Boolean,
      default: true
    }
})

</script>


<style scoped>
#title {
    text-align: center;
    font-size: 1rem;
    letter-spacing: 0.05rem;
    padding: 0;
}

</style>
